import formatObjectToSearchParams from 'helpers/formatObjectToSearchParams';
import envVars from 'helpers/envVars';
import request from 'helpers/request';
import * as DTO from './dto';

const domain = envVars('API_PAINEL_DIGITAL_BASE_URL');

export async function getInfosCards({ dealerId }: DTO.QueryCommonProp) {
  const { data } = await request.get<DTO.GetInfosCardsResponse>(
    `${domain}/dealer/${dealerId}/proposal/alert-panel/v1.0/cards`
  );

  return data;
}

export async function getListLeadsAlertPanel({
  dealerId,
  leadsAlertPanel,
  page = 5,
  size = 0,
}: DTO.GetListLeadsAlertPanelQuery) {
  const params = formatObjectToSearchParams({
    leadsAlertPanel,
    page,
    size,
  });

  const { data } = await request.get<DTO.GetListLeadsAlertPanelResponse>(
    `${domain}/dealer/${dealerId}/proposal/alert-panel/v1.0/list${params}`
  );

  return data;
}

export async function getNewAlerts({ dealerId }: DTO.QueryCommonProp) {
  const { data } = await request.get<DTO.GetListLeadsAlertPanelResponse>(
    `${domain}/dealer/${dealerId}/proposal/alert-panel/v1.0/button`
  );

  return data;
}
